let widgets = {
  Blip: require("./widget/Blip"),
  Calendar: require("./widget/Calendar"),
  Check: require("./widget/Check"),
  DatePicker: require("./widget/DatePicker"),
  Drop: require("./widget/Drop"),
  FormControls: require("./widget/FormControls"),
  FormDate: require("./widget/FormDate"),
  FormFeedback: require("./widget/FormFeedback"),
  FormFiles: require("./widget/FormFiles"),
  FormRange: require("./widget/FormRange"),
  IconButton: require("./widget/IconButton"),
  Meter: require("./widget/Meter"),
  Orderable: require("./widget/Orderable"),
  Pulse: require("./widget/Pulse"),
  QuickSearch: require("./widget/QuickSearch"),
  Slider: require("./widget/Slider"),
  Tabs: require("./widget/Tabs"),
  Table: require("./widget/Table"),
  Toggle: require("./widget/Toggle")
};

module.exports = widgets;
